const angular = require('angular')
module.exports = ['$scope', '$rootScope', '$translate', 'contactListService', 'contactListMixin', '$stateParams', '$state', '$utils', '$ionicScrollDelegate', 'contactService', '$q', '$sce', '$phoneModal', '$ionicHistory', 'LocalStorage', '$ionicListDelegate',
  function ($scope, $rootScope, $translate, contactListService, ContactListMixin, $stateParams, $state, $utils, $ionicScrollDelegate, contactService, $q, $sce, $phoneModal, $ionicHistory, LocalStorage, $ionicListDelegate) {
    if ($state.current.name === 'frame.personalContact') {
      initPersonalContact()
    }
    if ($state.current.name === 'frame.personalContactList') {
      initPersonalContactList()
    }
    // 初始化个人通讯录分组页
    function initPersonalContact() {
      $scope.isLoading = true
      contactService.getPersonalGroups().then(function(data) {
        if (angular.isArray(data)) {
          $scope.personalGroupArr = data
        }
      }, function (data) {
        $scope.personalGroupArr = data
      }).finally(_ => {
        $scope.isLoading = false
      })
    }
    // 初始化个人通讯分组联系人列表页
    function initPersonalContactList() {
      setGroupName($stateParams.groupid)
      getAllContacts($stateParams.groupid)
    }

    // 设置分组标题
    function setGroupName(groupid) {
      contactService.getPersonalGroups().then(function(data) {
        if (angular.isArray(data)) {
          data.forEach(function(item) {
            if (groupid === item.id) {
              $scope.groupName = item.name
            }
          })
        }
      })
    }
    // 获取指定个人通讯录分组下的所有联系人数据
    function getAllContacts(groupid, cache, showToast, message) {
      $scope.isLoading = true
      $scope.groupid = groupid
      $scope.start = 0
      $scope.limit = 20
      $scope.contactsArrUnderGroup = []
      contactService.getGroupPabContacts(groupid, false).then(function (data) {
        $scope.allCurrentGroupContacts = data
        $scope.total = data.length
        listContacts()
        showLoadMoreContact()
      }, function (error) {
        console.log(error)
        $utils.notify.set({ message: $translate.instant('ADDRESSBOOK.FETCH_CONTACTSINFO_ERROR') })
      }).finally(_ => {
        $scope.$broadcast('CONTACT_LIST.CONTENT_LOADED')
        $scope.isLoading = false
      })
    }
    // 控制显示加载更多或没有更多按钮（由于接口局限，此处的分页是前端拿到所有数据后进行的分页）
    function showLoadMoreContact() {
      if ($scope.contactsArrUnderGroup.length === $scope.total) {
        $scope.moreListData = false
      } else {
        $scope.moreListData = true
      }
    }
    // 根据start,limit显示联系人列表
    function listContacts() {
      if ($scope.start + $scope.limit < $scope.total) {
        $scope.contactsArrUnderGroup = $scope.contactsArrUnderGroup.concat($scope.allCurrentGroupContacts.slice($scope.start, $scope.start + $scope.limit))
        $scope.start = $scope.start + $scope.limit
      } else {
        $scope.contactsArrUnderGroup = $scope.contactsArrUnderGroup.concat($scope.allCurrentGroupContacts.slice($scope.start))
      }
    }
    // 加载更多联系人
    $scope.getMoreContactList = function () {
      listContacts()
      showLoadMoreContact()
    }
    // 显示右上角新建操作列表
    $scope.showOperation = function ($event) {
      if (!$scope.showFuncPanel) {
        LA.track('A2C2B1')
        $scope.showFuncPanel = true
        document.addEventListener('click', handleOperationOtherClick, false)
        $event.stopPropagation()
      }
      function handleOperationOtherClick(event) {
        document.removeEventListener('click', handleOperationOtherClick)
        $scope.showFuncPanel = false
        $scope.$digest()
      }
    }
    $scope.goSubFrame = function(frame, param = {}) {
      switch (frame) {
        case 'frame.createContact':
          window.backTarget = $ionicHistory.currentView() && $ionicHistory.currentView().url
          LA.track('A2C2B101')
          break
        case 'frame.createGroup':
          LA.track('A2C2B102')
          break
      }
      $state.go(frame, param)
    }
    // 打开搜索模态框
    let clearWatch
    $scope.inSearchPage = function () {
      LA.track('A2B2')
      $scope.pabSearchModal = $phoneModal.fromTemplate(require('views/addressBook/pabSearchModal.html'), {
        scope: $scope,
        animation: 'scale-in'
      })
      $scope.pabSearchModal.el.style.zIndex = 15
      $rootScope.isPabSearch = true
      $scope.search.keyword = ''
      $scope.searchStart = 0
      $scope.searchLimit = 20
      $scope.searchShowList = []
      $scope.noResultFound = false
      $scope.hideSearchMore = true
      $utils.$modalFunc.prepareModalBack($scope.pabSearchModal)
      $scope.pabSearchModal.show()
      const currentStateId = $ionicHistory.currentView().stateId
      clearWatch = $scope.$watch(function () {
        return $ionicHistory.currentView().stateId
      }, function (newValue) {
        if (newValue === currentStateId && $scope.pabSearchModal) {
          $scope.pabSearchModal.show()
        } else if (!$scope.pabSearchModal) {
          clearWatch()
        }
      })
      $scope.$broadcast('CONTACT_SEARCH.CONTENT_LOADED')
    }
    // 关闭搜索模态框
    $scope.closePabSearchModal = function () {
      $rootScope.isPabSearch = false
      $scope.searchStart = 0
      $scope.searchLimit = 20
      $scope.searchShowList = []
      $scope.noResultFound = false
      $scope.hideSearchMore = true
      $scope.search.keyword = null
      $scope.pabSearchModal.remove()
    }
    // 搜索联系人
    $scope.search = function () {
      $scope.searchShowList = []
      $scope.noResultFound = false
      $scope.isSearchLoading = true
      $scope.search.notFoundKeyword = $scope.search.keyword
      contactService.findPabContacts($scope.search.keyword).then(function (result) {
        if (result.length === 0) {
          $scope.noResultFound = true
        } else {
          $scope.searchShowList = wrapContacts(result)
        }
      }, function () {
      }).finally(function() {
        $scope.isSearchLoading = false
      })
    }
    // 对传入的联系人数组做一些包装处理（高亮操作等）
    function wrapContacts(contacts) {
      contacts.forEach(function (item) {
        item.highLightName = highLightKeyword($scope.search.keyword, item['FN'])
        item.highLightEmail = highLightKeyword($scope.search.keyword, item['EMAIL;PREF'])
      })
      return contacts
    }
    // 高亮字段中的关键字
    function highLightKeyword(keyword, contactName) {
      if (contactName) {
        keyword = keyword.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        const pattern = new RegExp(keyword, 'i')
        const tempName = contactName.replace(pattern, "<span class='highlight'>$&</span>")
        return $sce.trustAsHtml(tempName)
      }
    }
    // 处理搜索结果点击
    $scope.handleSearchItemClick = function(id) {
      $state.go('frame.personalContactDetail', {contactid: id})
    }
    // 判断是否是星标联系人
    $scope.isStarContact = function(id) {
      return contactService.isStarDeptContact({type: 'contact', id: id})
    }
    // 设为星标联系人
    $scope.markStarContact = function(id, groupid, name, email) {
      $ionicListDelegate.closeOptionButtons()
      contactService.markStar({type: 'contact', payload: {id: id, groupid: groupid, name: name, email: email, type: 'pab'}}).then(function() {
      }, function() {
      })
    }
    // 取消星标联系人
    $scope.removeStarContact = function(id) {
      $ionicListDelegate.closeOptionButtons()
      contactService.removeStar({type: 'contact', id: id}).then(function() {
      }, function() {
      })
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/addressbook/organizational/contact/personalContactCtrl.js